import { render, staticRenderFns } from "./PrescriptionsFilteredList.vue?vue&type=template&id=131ef9df&scoped=true"
import script from "./PrescriptionsFilteredList.vue?vue&type=script&lang=js"
export * from "./PrescriptionsFilteredList.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionsFilteredList.vue?vue&type=style&index=0&id=131ef9df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ef9df",
  null
  
)

export default component.exports